import React from 'react'
import styled from 'styled-components'

const Wrapper = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  z-index: 100;
  background-color: rgba(0, 0, 0, .5);
`

const StyledModal = styled.div`
  max-width: 600px;
  background-color: ${({ theme }) => theme.color.face.light};
  border-radius: 15px;
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.45);
`

const Modal = ({ children, className = '' }) => (
  <Wrapper className={className}>
    <div className="container h-100 d-flex align-items-center justify-content-center">
      <StyledModal className="styled-modal p-5">{children}</StyledModal>
    </div>
  </Wrapper>
)

export default Modal